import fotoFernanda from '@/assets/v2/time-fernanda.webp';
import fotoGabi from '@/assets/v2/time-gabi.webp';
import fotoMarcela from '@/assets/v2/time-marcela.webp';
import fotoRachel from '@/assets/v2/time-rachel.webp';

/**
 * As quatro que tocam o clube.
 *
 * Texto adaptado do QuemSomos antigo: tirei o "Oi, eu sou a X" de cada
 * bio porque o nome já aparece logo acima, e dei um cargo à Gabriela,
 * que estava com o campo vazio e por isso era a única sem selo.
 *
 * A inclinação de cada polaroid é fixa e não alternada: alternância
 * regular fica com cara de padrão, não de fotos numa mesa.
 */
export const EQUIPE = [
  {
    id: 'rachel',
    nome: 'Rachel Marinho',
    cargo: 'CEO & Idealizadora',
    hue: 'rosa',
    inclinacao: -2.5,
    foto: fotoRachel,
    bio: 'Tenho 22 anos e curso Direito na UFAM. Sou a mente por trás do Lily — aquela que pensa em tudo e faz acontecer. Cuido da parte estratégica, administrativa e de todas as decisões do clube.',
  },
  {
    id: 'fernanda',
    nome: 'Fernanda Marinho',
    cargo: 'COO & Área Criativa',
    hue: 'coral',
    inclinacao: 2,
    foto: fotoFernanda,
    bio: 'Tenho 21 anos e curso Medicina Veterinária. Atuo no design e na parte operacional, e adoro transformar cada edição em algo especial. Sou viciada em suspense e na saga Crepúsculo.',
  },
  {
    id: 'gabi',
    nome: 'Gabriela Leocadia',
    cargo: 'Operações & Comunidade',
    hue: 'ameixa',
    inclinacao: -1.8,
    foto: fotoGabi,
    bio: 'Tenho 22 anos e curso Direito. No Lily, garanto que tudo esteja funcionando direitinho. Cuido da logística e da fofoca com a comunidade — dos bastidores aos detalhes.',
  },
  {
    id: 'marcela',
    nome: 'Marcela Ramos',
    cargo: 'CMO & Experience Design',
    hue: 'damasco',
    inclinacao: 2.4,
    foto: fotoMarcela,
    bio: 'Tenho 21 anos e curso Arquitetura. No Lily, transformo cada edição em uma experiência única. Cuido dos registros, do buffet e da confeitaria, garantindo que tudo seja inesquecível.',
  },
];

/**
 * O que está incluso — texto recuperado de dentro de `2.webp`, onde
 * hoje existe só como pixel dentro da imagem do carrossel.
 */
export const INCLUSO = [
  { titulo: 'Leitura do mês', detalhe: 'Escolhida por enquete' },
  { titulo: 'Encontro especial', detalhe: 'Presencial, uma vez por mês' },
  { titulo: 'Comunidade', detalhe: 'Gratuita, no WhatsApp' },
  { titulo: 'Mimos e dinâmicas', detalhe: 'Inclusos no ingresso' },
];

export const COMO_FUNCIONA = [
  {
    titulo: 'Vocês escolhem o livro',
    texto:
      'No início do mês, uma enquete na comunidade do WhatsApp decide qual será a próxima leitura.',
  },
  {
    titulo: 'As inscrições abrem',
    texto:
      'Pelo site, com dois horários para você escolher o que cabe na sua rotina. O PDF e o ePub ficam na comunidade.',
  },
  {
    titulo: 'A gente se encontra',
    texto:
      'Presencial, em Manaus, com comidinhas, dinâmicas e decoração pensada para a obra do mês.',
  },
];
